import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { Layout } from "@/components/Layout";
import Index from "./pages/Index";
import LoginPage from "./pages/auth/Login";
import NotFound from "./pages/NotFound";
import AuthGuard from "./components/AuthGuard";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ResetPasswordPage from "./pages/reset-password/ResetPasswordPage";
import SetNewPasswordPage from "./pages/reset-password/SetNewPassword";
import LoanStatementPage from "./pages/LoanStatementPage";
import ApplyLoan from "./pages/ApplyLoanPage";
import LandingPage from "./pages/landing-page/LandingPage";
import RegisterPage from "./pages/auth/RegisterPage";
import SpinWinPage from "./pages/games/SpinWinPage";



const queryClient = new QueryClient();

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const dir = i18n.dir(); // "ltr" or "rtl"
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", i18n.language);

    // Optional: helper class for CSS tweaks
    document.documentElement.classList.toggle("rtl", dir === "rtl");
  }, [i18n.language, i18n]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            {/* your Routes exactly as-is */}
            <Routes>
              {/* PUBLIC ROUTE */}
              <Route path="/" element={<LandingPage />} />
                <Route path="/register" element={<RegisterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/set-password" element={<SetNewPasswordPage />} />
 <Route path="/spin-win" element={<SpinWinPage />} />

              {/* 🔐 PROTECTED ROUTES */}
              <Route
                element={
                  <AuthGuard>
                    <Layout />
                  </AuthGuard>
                }
              >
                <Route path="/home" element={<Index />} />


                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/loan-statement" element={<LoanStatementPage />} />
                <Route path="/apply-loan" element={<ApplyLoan />} />

              </Route>

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;